
import {IdentityDoc} from '@pp-frontend/shared-packages/types/dto/IdentityDoc'
import {Component, Prop, Vue} from 'nuxt-property-decorator'
// @todo rm ignores
// игноры расставлены из-за того что тип документа не верно сделан, нужен новый IdentityDoc который правильно типизирует
@Component
export default class DocWidgetListItem2 extends Vue {
  @Prop() doc: IdentityDoc
  @Prop({ default: false }) newType: boolean

  formatName (name: string): string {
    const parts = name.split(' ');
    const lastName = parts[0];
    const firstInitial = parts[1][0];
    const middleInitial = parts[2][0];

    return `${lastName} ${firstInitial}. ${middleInitial}.`;
  }
  get docDisplayText() {
    //@ts-ignore
    const { licence_plate, vehicle_model } = this.doc.additional_fields
    let text: string[] = []

    switch (this.doc.document_type) {
      case 'licence_plate':
        if (vehicle_model) {
          text.push(vehicle_model)
        }
        text.push(this.doc.document_value)
        break;
      case 'ctc':
        if (vehicle_model) {
          text.push(vehicle_model)
        }
        if (licence_plate) {
          text.push(licence_plate)
        }
        if (!licence_plate || !vehicle_model) {
          text.push(`СТС ${this.doc.document_value}`)
        }
        break;
      case 'vu':
        text.push(`ВУ ${this.doc.document_value}`)
        break;
      case 'uin':
        text.push(`УИН ${this.doc.document_value}`)
        break;
      case 'passport':
        //@ts-ignore
        let passportBDay = this.$formatters.formatDate(this.doc.additional_fields.birth_date)
        //@ts-ignore
        text.push(this.doc.owner_name)
        text.push(`${this.doc.document_value}, ${passportBDay}`)
        break;
      case 'inn':
        if (this.doc.owner_name) {
          text.push(this.doc.owner_name)
        }
        text.push(`ИНН ${this.doc.document_value}`)
        break;
      case 'fio_birth_date_requisite':
        //@ts-ignore
        let regionLabel = this.$store.getters['regions/getRegionLabelByCode'](this.doc.document_value.region_id)
        //@ts-ignore
        let bDay = this.$formatters.formatDate(this.doc.document_value.birth_date)

        if (this.newType) {
          //@ts-ignore
          text.push(this.formatName(this.doc.document_value.fio))
        } else {
          //@ts-ignore
          text.push(this.doc.document_value.fio)
        }
        text.push(`${regionLabel}, ${bDay}`)
        break;
      default:
        if (typeof this.doc.document_value === 'string') {
          text.push(this.doc.document_value)
        }
        break;
    }
    return text
  }
}
